import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="bg-white py-10 px-6 md:py-16" data-id="element-124">
      <div className="max-w-3xl mx-auto" data-id="element-125">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="border-2 border-gold rounded-lg p-8 md:p-12 text-center bg-cream" data-id="element-126">
          <ShieldCheckIcon className="mx-auto mb-6 text-gold" size={64} data-id="element-127" />

          <h2 className="font-playfair text-3xl md:text-4xl text-charcoal mb-6" data-id="element-128">
            Garantie "Souveraine"
          </h2>

          <div className="space-y-4 text-lg leading-relaxed" data-id="element-129">
            <p data-id="element-130">
              Télécharge le pack complet. Applique la méthode pendant 30 jours.
            </p>

            <p data-id="element-131">
              Si tu ne ressens pas le début d'un changement — si tu ne commences
              pas à regarder le miroir différemment, si tu ne trouves pas au
              moins une action qui t'a redonné de la force —
            </p>

            <p className="font-semibold text-burgundy" data-id="element-132">
              Envoie-moi un simple email. Je te rembourse 100% de ton
              investissement. Sans question. Sans délai.
            </p>

            <p className="text-xl font-semibold text-gold" data-id="element-133">
              Et tu gardes tous les guides.
            </p>

            <p data-id="element-134">
              Parce que je suis convaincue que tu n'auras pas besoin de ce
              remboursement.
            </p>

            <p className="italic text-charcoal pt-4" data-id="element-135">
              — Avec confiance et bienveillance.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}